import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { getJudgesDesignations } from 'features/Tdsat/API/TdsatApi';

const useStyles = makeStyles((theme) => ({
  label: {
    color: '#121212',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
  
}));

const JudgesDesignationInput = ({
  value = '', 
  onChange, 
  isRequired=false,
  size='medium', 
  type = 'MainCase', 
  isLabel = true, 
  isInlineLabel = true,
  label = '',
  error = null,
  name = '',
  formControlStyles,
}) => {
  const classes = useStyles();

  const [judgesDesignationOptions, setJudgesDesignationOptions] = useState([]);

  useEffect(() => {
    getJudgesDesignations().then((res) => {
      setJudgesDesignationOptions(res.data);
    });
  },[])
  
  return (
    <>
      <FormControl required={isRequired} fullWidth margin="none" variant="outlined" size={size} style={formControlStyles}>
        {isLabel && (
          isInlineLabel ? (
            <InputLabel id={label}>{label}</InputLabel>
          ) : (
            <Typography className={classes.label}>{label}</Typography>
          )
        )}
        <Select
          name={name}
          value={value}
          onChange={onChange}
          labelId={label}
          label={isInlineLabel && label}
        >
          <MenuItem>Select</MenuItem>
          {judgesDesignationOptions?.map((item, index)=>{
            return (
              <MenuItem key={index} value={item}>{item}</MenuItem>
            )
          })}
        </Select>
        {error && (
          <FormHelperText style={{color:'red', margin:0}}>{error}</FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default JudgesDesignationInput;
